export default ({ app }) => {
  if (process.client) {
    const script = document.createElement('script')
    script.src = '//sdk.51.la/js-sdk-pro.min.js'
    script.setAttribute('id', 'LA_COLLECT')
    script.setAttribute('charset', 'UTF-8')
    document.head.appendChild(script)
  }
}
